import confetti from 'canvas-confetti';

export function fireConfettiBurst(originY = 0.5) {
	const y = Math.min(originY, 0.9);

	confetti({ particleCount: 120, spread: 80, origin: { x: 0.5, y }, colors: ['#f59e0b', '#1c79bb', '#fcd34d', '#ffffff', '#9c1369'] });
	setTimeout(() => confetti({ particleCount: 60, spread: 55, origin: { x: 0.35, y: 0.6 }, colors: ['#f59e0b', '#1c79bb'] }), 200);
	setTimeout(() => confetti({ particleCount: 60, spread: 55, origin: { x: 0.65, y: 0.6 }, colors: ['#f59e0b', '#1c79bb'] }), 350);
}
